/**
 * CpfUtil
 */
export function validarCpf(documento: string, addValidateMsg?): boolean {
  documento = normalizar(documento);

  if (documento == null || documento.trim() == '') {
    if (addValidateMsg != null)
      addValidateMsg('- <b>CPF</b> em branco.');
    return false;
  }

  if (documento.match('.*[^\\d].*')) {
    if (addValidateMsg != null)
      addValidateMsg('- <b>CPF</b> contém caracteres inválidos.');
    return false;
  }

  if (documento.length != 11) {
    if (addValidateMsg != null)
      addValidateMsg('- <b>CPF</b> deve conter 11 dígitos.');
    return false;
  }

  if (documento == '00000000000' || documento == '11111111111' || documento == '22222222222') {
    if (addValidateMsg != null)
      addValidateMsg('- <b>CPF</b> inválido.');
    return false;
  }

  var digitoVerificador: Number = Number.parseInt(documento.substring(documento.length - 2, documento.length));
  var digitoCalculado: Number = calcularDigitoVerificador(documento);

  if (digitoVerificador != digitoCalculado) {
    if (addValidateMsg != null)
      addValidateMsg('- <b>CPF</b> inválido.');
    return false;
  }

  return true;
}

export function normalizar(cpf: string): string {
  if (cpf != null && cpf.trim() != '') {
    cpf = cpf.trim().replace(new RegExp('(-|\\.|\\s)', 'g'), '');

    while (cpf.length < 11) {
      cpf = '0' + cpf;
    }
  }
  return cpf;
}

export function calcularDigitoVerificador(documento: string): Number {
  var d1: number = 0, d2: number = 0;
  for (let nCount: number = 1; nCount < documento.length - 1; nCount++) {
    var digito: number = parseInt(documento.substring(nCount - 1, nCount));

    //multiplique a ultima casa por 2 a seguinte por 3 a seguinte por 4 e assim por diante.
    d1 += (11 - nCount) * digito;

    //para o segundo digito repita o procedimento incluindo o primeiro digito calculado no passo anterior.
    d2 += (12 - nCount) * digito;
  }

  var digito1, digito2, resto: number;

  //Primeiro resto da divisão por 11.
  resto = (d1 % 11);

  //Se o resultado for 0 ou 1 o digito é 0 caso contrário o digito é 11 menos o resultado anterior.
  if (resto < 2)
    digito1 = 0;
  else
    digito1 = 11 - resto;

  d2 += 2 * digito1;

  //Segundo resto da divisão por 11.
  resto = (d2 % 11);

  //Se o resultado for 0 ou 1 o digito é 0 caso contrário o digito é 11 menos o resultado anterior.
  if (resto < 2)
    digito2 = 0;
  else
    digito2 = 11 - resto;

  return 10 * digito1 + digito2;
}



// WEBPACK FOOTER //
// ./src/util/cpfutil.ts